import { Brand } from '../Brands/brands.reducer';
import actionCreatorFactory from 'typescript-fsa';
const actionCreator = actionCreatorFactory('CmsBrands');

export const updateCmsBrandEntities = actionCreator<{
  brands: {
    [key: number]: Brand;
  };
  appId: number;
}>('ENTITIES_UPDATE');

export const loadCmsBrands = actionCreator('CMS_BRANDS_LOAD');



// WEBPACK FOOTER //
// ./src/store/Entities/CmsBrands/cmsbrands.actions.ts